import { render } from "./user-layout2.vue?vue&type=template&id=a4ca238c&scoped=true&ts=true"
import script from "./user-layout2.vue?vue&type=script&lang=ts"
export * from "./user-layout2.vue?vue&type=script&lang=ts"

import "./user-layout2.vue?vue&type=style&index=0&id=a4ca238c&lang=less&scoped=true"

import exportComponent from "/web/CMES_Login_PC/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4ca238c"]])

export default __exports__